export default __webpack_public_path__ + "static/ddc08bef81662fd3452a252b615d4301.svg";